import { Link } from 'react-router-dom';
import { Button } from '../design-system/atoms/Button';
import { EmptyState } from '../design-system/atoms/EmptyState';

export function NotFound() {
  return (
    <div style={{ flex: 1, display: 'grid', placeItems: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 320, display: 'grid', gap: 14 }}>
        <EmptyState icon="🧭" title="Страница не найдена" text="Проверьте адрес или вернитесь на главную." />
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Button fw ch="НА ГЛАВНУЮ" />
        </Link>
      </div>
    </div>
  );
}
